import Switch, { SwitchProps } from '@shared/components/Switch/Switch';
import Tooltip from '@shared/components/Tooltip/Tooltip';

interface SwitchWithDisabledFeatureTooltipProps extends SwitchProps {
  label?: string;
}

const SwitchWithDisabledFeatureTooltip = (props: SwitchWithDisabledFeatureTooltipProps) => {
  const { label, ...switchProps } = props;

  if (switchProps.disabled && label) {
    return (
      <Tooltip label={label} inPortal>
        <Switch {...switchProps} />
      </Tooltip>
    );
  }

  return <Switch {...switchProps} />;
};

export default SwitchWithDisabledFeatureTooltip;
